import Vue from 'vue';
import toastVue from './toast.vue';
import merge from '@/utils/merge';

const defaults = {
    text: '加载中',
    time: 2000
};
const ToastConstructor = Vue.extend(toastVue);

ToastConstructor.prototype.close = function() {
    if (this._el != null) {
        document.body.removeChild(this._el) //从body中移除dom
    }
    if (this._instance != null) {
        this._instance.$destroy() //销毁组件
    }
    if (this._vm != null) {
        this._vm = null //让GC回收
    }
}

ToastConstructor.prototype.update = function(options) {
    if (this._instance != null) {
        this._instance.update(options)
    }
}

ToastConstructor.prototype.restartTimer = function() {
    if (this._instance != null) {
        this._instance.startTimer()
    }
}

const Toast = (options => {
    if (options.text) {
        options = merge({}, defaults, options);
    } else {
        options = merge(defaults, {
            text: options
        });
    }
    if (window.__ToastInstance) {
        window.__ToastInstance.update(options);
        window.__ToastInstance.restartTimer();
        return window.__ToastInstance;
    } else {
        let instance = new ToastConstructor({
            data: options
        });
        instance._vm = instance.$mount()
        instance._el = instance.$el
        instance._instance = instance
        document.body.appendChild(instance.$el) // 把生成的提示的dom插入body中
        window.__ToastInstance = instance;
        return instance;
    }
})

export default Toast